import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "../link/Link";
import { shouldHandleMouseEvent, useTabTrigger } from "./useTabTrigger";
import { useTabTrigger as useTabTrigger2 } from "./useTabTrigger";
function TabTrigger(param) {
  var { asChild, name, href, resetOnFocus, ...props } = param;
  var _ref;
  var { trigger, triggerProps } = useTabTrigger({
    name,
    resetOnFocus,
    ...props
  });
  var resolvedHref = (_ref = trigger === null || trigger === void 0 ? void 0 : trigger.resolvedHref) !== null && _ref !== void 0 ? _ref : href;
  if (!resolvedHref) {
    return /* @__PURE__ */ _jsx("button", {
      type: "button",
      onClick: function onClick(event) {
        var _triggerProps_onPress;
        return (_triggerProps_onPress = triggerProps.onPress) === null || _triggerProps_onPress === void 0 ? void 0 : _triggerProps_onPress.call(triggerProps, event);
      },
      children: props.children
    });
  }
  return /* @__PURE__ */ _jsx(Link, {
    ...props,
    href: resolvedHref,
    asChild,
    onPress: function onPress(event) {
      var _triggerProps_onPress;
      if (!shouldHandleMouseEvent(event)) return;
      event.preventDefault();
      (_triggerProps_onPress = triggerProps.onPress) === null || _triggerProps_onPress === void 0 ? void 0 : _triggerProps_onPress.call(triggerProps, event);
    },
    onLongPress: triggerProps.onLongPress,
    "aria-current": (trigger === null || trigger === void 0 ? void 0 : trigger.isFocused) ? "page" : void 0,
    ...asChild ? {
      isFocused: Boolean(trigger === null || trigger === void 0 ? void 0 : trigger.isFocused)
    } : null,
    children: props.children
  });
}
function isTabTrigger(child) {
  return child.type === TabTrigger;
}
export {
  TabTrigger,
  isTabTrigger,
  useTabTrigger2 as useTabTrigger
};
//# sourceMappingURL=TabTrigger.js.map
